import * as React from 'react';
import { useSelector } from 'react-redux';
import { Button, LinkButton, Responsive } from '@cian/ui-kit';
import { IconCommunicationPhone16 } from '@cian/ui-kit-design-tokens/icons';
import { selectBuilder } from '../../selectors';
import { IBaseButtonProps } from '@cian/ui-kit/button/types';
import { ContactsModal } from '../../components/ContactsModal';

interface ICallButtonContainerProps extends IBaseButtonProps {
  showIcon?: boolean;
  showText?: boolean;
  onCallClick?(): void;
}

export const CallButtonContainer: React.FC<ICallButtonContainerProps> = ({
  showIcon = false,
  showText = true,
  onCallClick,
  ...props
}) => {
  const [modalOpened, setModalOpened] = React.useState(false);
  const { name, logo, phone } = useSelector(selectBuilder);
  const icon = showIcon ? <IconCommunicationPhone16 color="icon-on-bright-default" /> : undefined;
  const buttonText = showText ? 'Показать телефон' : undefined;
  const linkText = showText ? 'Позвонить' : undefined;

  if (!phone) {
    return null;
  }

  return (
    <>
      <Responsive tablet>
        <Button {...props} data-name="CallButtonShowContacts" beforeIcon={icon} onClick={() => setModalOpened(true)}>
          {buttonText}
        </Button>
      </Responsive>
      <Responsive phone>
        <LinkButton {...props} data-name="CallButtonLink" beforeIcon={icon} href={`tel:${phone}`} onClick={onCallClick}>
          {linkText}
        </LinkButton>
      </Responsive>
      <ContactsModal
        name={name}
        logo={logo}
        phone={phone}
        open={modalOpened}
        onClose={() => setModalOpened(false)}
        onCallClick={onCallClick}
      />
    </>
  );
};
